import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import { Alert, AlertTitle } from '@mui/lab';

import { connect } from 'react-redux'

import Icon from '../narrative/icon'
import SchedulesButton from "./schedules-button";

import {
  setViewedRoute,
  setViewedTrip,
  setViewedRouteSelectedIndex,
  setMainPanelContent,
  calcRemainingHeight
} from '../../actions/ui'
import {findTrip, findStopTimesForStop} from '../../actions/api'
import { setLocation } from '../../actions/map'

import { formatSecondsAfterMidnight, getTimeFormat } from '../../@opentripplanner/core-utils/src/time'
import i18n from "../../../i18nSetup";
import Grid from '@mui/material/Grid';
import {rewriteHeadsign} from '../../actions/ui'
import { getFormattedStopTime } from './stop-time';
import ChangeRouteDirection from "./change-route-direction";
import {ReactComponent as ArrowBackIcon} from "../../assets/arrowBack.svg";

class TripViewer extends Component {
  static propTypes = {
    hideBackButton: PropTypes.bool,
    tripData: PropTypes.object,
    viewedTrip: PropTypes.object
  }



    constructor () {
    super()
    this.state = { alertsExpanded: new Set()}
  }


  _backClicked = () => {
    this._stopAutoRefresh()
    this.props.setViewedTrip(null)
    this.props.setViewedRoute(null)
    if(this.props.viewedRoute)
        this.props.setMainPanelContent(null)
  }

  _refreshStopTimes = () => {
    const { findStopTimesForStop,stopData } = this.props
    if(!stopData)
        return;
    findStopTimesForStop({ stopId: stopData.id})
    // TODO: GraphQL approach would just call findStop again.
    // findStop({ stopId: viewedStop.stopId })
   
  }

  _startAutoRefresh = (stopId) => {
    this._stopAutoRefresh();
    this.props.findStopTimesForStop({ stopId })
    this.stopTimer = window.setInterval(this._refreshStopTimes, 30000)
    
  }

  _stopAutoRefresh = () => {
    if(!this.stopTimer)
        return
    window.clearInterval(this.stopTimer)
    this.stopTimer = null;
  }

  componentDidMount () {
    const { findTrip, viewedTrip } = this.props
    if(viewedTrip){
      const { tripId } = viewedTrip
      findTrip({ tripId })
    }
  }

  componentDidUpdate(prevProps){
    if (this.props.stopData && (!prevProps.stopData || (prevProps.stopData.id !== this.props.stopData.id))) {
      this._startAutoRefresh(this.props.stopData.id)
    }
  }
  
  componentWillUnmount () {
    // Turn off auto refresh unconditionally (just in case).
    this._stopAutoRefresh()
  }

  //<div>{i18n.t('route')}: <b>{tripData.route.shortName}</b> {tripData.headsign ? rewriteHeadsign(tripData.headsign) : rewriteHeadsign(tripData.tripHeadsign) }</div>
  //</div>

  render () {
    const {
      hideBackButton,
      timeFormat,
      tripData,
      viewedTrip,
      dir,
      alerts,
      viewedRoute
    } = this.props

    let backgroundColor = '#' + (tripData ? (tripData.routeColor || tripData.route?.color || '000') : '000');
    let color = '#' + (tripData ? (tripData.textColor || tripData.route?.textColor || 'FFFFFF') : 'FFFFFF');
    const stackIcon = (name, color, size) => <i className={`fa fa-${name} fa-stack-1x`}
                                                style={{color, fontSize: size + 'px'}}/>

    let appendix = "";
    if(tripData.route && 715 == tripData.route.type){
      appendix += i18n.t("ADVANCED_BOOKING_REQUIRED");
    }
    return (
      <div className='trip-viewer'>
        {/* Header Block */}
        <div className='trip-viewer-header'>
          {/* Back button */}
          {!hideBackButton && (
            <Button startIcon={<ArrowBackIcon  style={{transform:(dir === 'rtl') ? 'scaleX(-1)': 'none'}}/>} style={{
              color: '#4B33A5',
              justifyContent: "flex-start",
              paddingRight: 2,
              paddingLeft: 2
            }} variant="plain"
                    onClick={this._backClicked}>{i18n.t('back')}</Button>
          )}
          {tripData && (
             <div className='header-text' style={{display:'flex',alignItems:'center',alignContent:'center'}}>
                <Box mx="auto" fontWeight="fontWeightBold" sx={{marginLeft:1 ,marginRight:1 ,paddingLeft:1, paddingRight:1, alignContent:'center', textAlign:'center', verticalAlign:'center',
                  backgroundColor: backgroundColor === '#ffffff' ? 'rgba(0,0,0,0)' : backgroundColor,
                  color,
                  borderRadius: '2px'
                }}>
                  {tripData.routeShortName || tripData.route.shortName}
                </Box>
             </div>
          )}
          <div style={{clear: 'both'}}/>
        </div>
        {tripData && tripData.route && (tripData.route.agency || tripData.agencyName) && (<span
          style={{fontSize: 14, marginTop: 0, marginBottom: 0, paddingInlineStart: 12}}>{i18n.t('ServiceOperatedBy')} <a
          href={tripData.agencyUrl || tripData.route.agency?.url} target='_blank'
          rel="noreferrer">{tripData.agencyName || tripData.route.agency?.name}</a></span>)}

        <Box mt={2} sx={{
          backgroundColor: '#F0F0F0',
          paddingTop: 0,
          paddingBottom: 0
        }}>
          <Box p={2}>
            <Box>
              <Typography type="body2" sx={{
                display: 'inline-block',
                fontWeight: 'bold'
              }}>{i18n.t('toDirect')} {rewriteHeadsign(tripData.headsign || tripData.tripHeadsign || tripData.rawTripHeadsign) + appendix}</Typography>
            </Box>
            {tripData.route && tripData.route.id && (<ChangeRouteDirection tripData={tripData}/>)}
          </Box>
        </Box>

        <Box id={'stops-list-view'}>
          <Box sx={{width: '100%', overflow: 'auto', maxHeight: calcRemainingHeight('stops-list-view', 40)}}>

        {alerts && alerts.length && (

          <div>{alerts.map((routeAlert, index) => (<Alert
            key={'alert_' + index}
            sx={{fontSize: 14, marginTop: 2, marginBottom: 0}}
            severity="warning">
            <AlertTitle sx={{fontSize: 14, marginTop: 0, marginBottom: 0}} onClick={() => {
              let alertsExpanded = this.state.alertsExpanded;
              if (alertsExpanded.has(routeAlert.entityId)) {
                alertsExpanded.delete(routeAlert.entityId)
              } else {
                alertsExpanded.add(routeAlert.entityId)
              }

            this.setState({alertsExpanded})
          }
            }>{routeAlert.alert.alertHeaderText}</AlertTitle>
          {this.state.alertsExpanded.has(routeAlert.entityId) ? routeAlert.alert.alertDescriptionText : null}
        </Alert>))}
        </div>
         )}

        
            <div className='trip-viewer-body'>
              {tripData && tripData.stops && (
                tripData.stops.map((stop, i) => {
                  let times;
                  if (!this.props.stopData || this.props.stopData.id !== stop.id || !this.props.stopData.stopTimes) {
                    times = null;
                  } else {
                    if (viewedRoute) {
                      let pattern = viewedRoute.pattern;
                      times = this.props.stopData.stopTimes.find(times => {
                      return times.pattern.id === pattern;
                    })

                  } else if (viewedTrip) {

                    times = this.props.stopData.stopTimes.find(times => {
                      return times.pattern.route.id === viewedTrip.leg.routeId
                    })
                  }
                }

                if (!times || !times.times || !times.times.length)
                  times = null;
                // determine whether to use special styling for first/last stop
                let stripMapLineClass = 'strip-map-line'
                if (i === 0) stripMapLineClass = 'strip-map-line-first'
                else if (i === tripData.stops.length - 1) stripMapLineClass = 'strip-map-line-last'

                // determine whether to show highlight in strip map
                let highlightClass
                if(viewedTrip){
                  if (i === viewedTrip.fromIndex) highlightClass = 'strip-map-highlight-first'
                  else if (i > viewedTrip.fromIndex && i < viewedTrip.toIndex) highlightClass = 'strip-map-highlight'
                  else if (i === viewedTrip.toIndex) highlightClass = 'strip-map-highlight-last'
                }

                return (
                  <Grid container wrap='nowrap' direction="row" spacing={0} key={'stop_' + i} onClick={() => {
                    if(i === this.props.selectedIndex)
                      return
                    if(this.props.viewedRoute){
                      this.props.setViewedRouteSelectedIndex(i);
                      this._startAutoRefresh(stop.id);
                    }
                    //  this.setState({expandIndex:i,selectedStopId:stop.id},() => {

                    //  })

                  }}>
                    {/* the departure time */}
                    {viewedTrip && tripData && tripData.stopTimes &&
                    <Grid item>
                      <div className='stop-time'>
                        {formatSecondsAfterMidnight(tripData.stopTimes[i].scheduledDeparture, timeFormat)}

                      </div>
                    </Grid>}

                    <Grid item>
                      <div className='strip-map-container'>
                        {highlightClass && <div className={highlightClass}/>}
                        <div className={stripMapLineClass} style={{backgroundColor}}/>
                        <Box sx={{position: 'absolute', ml: '-6px'}}>
                        <span className='fa-stack'>
                          {stackIcon('circle', i === this.props.selectedIndex ?  backgroundColor : 'white', 12)}
                          {stackIcon('circle-o',  backgroundColor, 12)}
                       </span>
                        </Box>
                      </div>
                    </Grid>

                    {/* the main stop label */}
                    <Grid item xs={8}>
                      <div className={i === this.props.selectedIndex ? 'stop-name-selected' : 'stop-name'}>
                        {stop.name}
                        {((i < tripData.stops.length -1 || (tripData.dropoffs && tripData.dropoffs[i]))  && tripData.pickups && tripData.pickups[i]) ? i18n.t('NO_PICKUP') : ""}
                        {(i > 0 && tripData.dropoffs && tripData.dropoffs[i] && (!tripData.pickups || !tripData.pickups[i])) ? i18n.t('NO_DROPOFF') : ""}
                      </div>
                      {(i === this.props.selectedIndex) && (<div><div className='stop-details'>

                        {(stop.code && stop.formatted_address) ? (stop.code + ' • ' +  stop.formatted_address) : (stop.code || stop.formatted_address)}
                        {this.renderStopTimes(stop.id)}

                        <SchedulesButton fontSize={12} stopName={stop.name} stopId={stop.id} routeId={tripData.routeId}
                                         lineColor={backgroundColor}
                                         textColor={color}
                                         lineNumber={tripData.routeShortName || tripData.route.shortName}
                                         targetTrip={rewriteHeadsign(tripData.headsign || tripData.tripHeadsign || tripData.rawTripHeadsign)}
                                         stopTimes={times?.times ?? null}/>

                      </div></div> )}

                    </Grid>

                    {(i === this.props.selectedIndex) && <Grid item>


                    </Grid>}

                    <div style={{clear: 'both'}}/>

                  </Grid>
                )
                })
              )}
            </div>
          </Box>
        </Box>
      </div>
    )
  }

  renderStopTimes(stopId){
    const { 
      homeTimezone,
      stopViewerArriving,
      timeFormat,
      viewedRoute,
      viewedTrip
     } = this.props
    if(viewedRoute && (!this.props.stopData || this.props.stopData.id !== stopId || !this.props.stopData.stopTimes)){
        return (<div>{i18n.t('updatingSchedule')}</div>)
    }

    let times;

    if(viewedRoute){
     let pattern = viewedRoute.pattern;
      times = this.props.stopData.stopTimes.find(times => {
          return times.pattern.id === pattern;
      })

    }else if(viewedTrip){

      times = this.props.stopData.stopTimes?.find(times => {
        return times.pattern.route.id === viewedTrip.leg.routeId
    })

    }

    if(!times || !times.times || !times.times.length)
        return null
    let result = times.times.map((stopTime,i) => {

      //console.log(stopTime);
      return (<div key={i} style={{flexDirection:'row',marginInlineEnd:8,marginTop:8,marginBottom:8}}>
      {getFormattedStopTime(stopTime, homeTimezone, stopViewerArriving, timeFormat,i > 0)}
      </div>)
    })

    return (<div style={{display:'flex'}}>{result}</div>)

  }
}

const mapStateToProps = (state, ownProps) => {
  const viewedRoute = state.otp.ui.viewedRoute
  const viewedTrip = state.otp.ui.viewedTrip
  const tripData = viewedTrip ? state.otp.transitIndex.trips[viewedTrip.tripId] : state.otp.transitIndex.routes[viewedRoute.routeId].patterns[viewedRoute.pattern];
  const alerts = viewedTrip ? null : state.otp.transitIndex.routes[viewedRoute.routeId].alerts;
  const selectedIndex = viewedTrip ? viewedTrip.fromIndex : (viewedRoute ? viewedRoute.selectedIndex : null)
  const stopId = viewedTrip ? viewedTrip.leg.from.stopId : ((null != selectedIndex) ? tripData.stops[selectedIndex].id : null);
  return {
    timeFormat: getTimeFormat(state.otp.config),
    tripData,
    viewedTrip,
    alerts,
    viewedRoute,
    stopData:(stopId) ? state.otp.transitIndex.stops[stopId] : null,
    selectedIndex,
    dir:state.otp.config.dir,
    homeTimezone: state.otp.config.homeTimezone,
    stopViewerArriving: state.otp.config.language.stopViewerArriving,
  }
}

const mapDispatchToProps = {
  setViewedTrip,
  findTrip,
  setLocation,
  setViewedRoute,
  setViewedRouteSelectedIndex,
  findStopTimesForStop,
  setMainPanelContent
}

export default connect(mapStateToProps, mapDispatchToProps)(TripViewer)
